export const global = Object.freeze({
	ACCESS_TOKEN: "access-token",
	REFRESH_TOKEN: "refresh-token",
	VIZYONEKS_CUSTOMER_NO: "vizyoneks-customer-no",
	AGITO_CUSTOMER_NO: "agito-customer-no",
	IS_AGITO_CUSTOMER: "is-agito-customer",
	IS_VIZYONEKS_CUSTOMER: "is-vizyoneks-customer",
	USER_TCKN: "user-tckn",
	USER_PHONE: "user-phone",
	BANK_TYPE: "bank-type",
	CHAT_STATUS: "chat-status",
	CHAT_NICKNAME: "chat-nickname",
	CHAT_MAIL: "chat-mail",
	CHAT_PHONE: "chat-phone",
	CHAT_MESSAGES: "chat-messages",
	CHAT_SECUREKEY: "chat-securekey",
	CHAT_AGENT: "chat-agent",
	INDIVIDUAL_HOMEPAGE: 'individual',
	TOKEN_EXPIRES: 1
})